import template from "./standalone_feedback.html";
import { WORKER_COMMENT } from "../../../safety/constants";
import en from "./en.translation.json";
import es from "./es.translation.json";
import mixpanel from "mixpanel-browser";

class StandaloneFeedbackController {
    /* @ngInject */
    constructor(CommentService) {
        this.CommentService = CommentService;
        this.newComment = {};
        this.showCommentCard = true;
    }

    $onInit() {}

    createComment(newComment) {
        let ctrl = this;
        ctrl.showSpinner = true;
        newComment.grower_organization = ctrl.grower.sid;
        newComment.author = ctrl.account.sid;
        newComment.category = WORKER_COMMENT;
        ctrl.CommentService.create(newComment)
            .then(
                function () {
                    mixpanel.track(
                        "Submitted worker comment from standalone feedback",
                        {
                            company_sid: ctrl.grower.sid,
                        },
                    );
                },
                function () {},
            )
            .then(function () {
                ctrl.showSpinner = false;
                ctrl.showCommentCard = false;
            });
    }
}

export default {
    bindings: { grower: "<", account: "<" },
    controller: StandaloneFeedbackController,
    template,
    name: "standaloneFeedback",
    translations: { en, es },
};
